import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationUpdateOnboardingStageArgs,
  BackendUserOnboardingStage,
} from 'src/types/backend';

import { FRAGMENT_ONBOARDING_STAGE } from './schema';

const MUTATION = gql`
  mutation UpdateOnboardingStage($name: String!, $status: String, $value: String) {
    updateOnboardingStage(name: $name, status: $status, value: $value) {
      ...UserOnboardingStage
    }
  }
  ${FRAGMENT_ONBOARDING_STAGE}
`;

type Variables = BackendMutationUpdateOnboardingStageArgs;
type Result = BackendUserOnboardingStage;

export const updateOnboardingStage = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
